import * as React from 'react'

import Spotlight from './Spotlight'

/**
 * Rings the spotlit topic node inside the 3D graph. The package can't draw it:
 * LazyGraph's stacking context sits under the dim, so it only reports the node's
 * viewport geometry, on a dedicated per-frame channel rather than the analytics
 * bus. No geometry means no ring.
 */

const GEOMETRY_EVENT = 'infranodus:topic-spotlight-geometry'

export default function GraphTopicSpotlight({ dim = true }) {
    const [geometry, setGeometry] = React.useState(null)

    React.useEffect(() => {
        const handleGeometry = event => setGeometry(event.detail || null)
        window.addEventListener(GEOMETRY_EVENT, handleGeometry)
        return () => window.removeEventListener(GEOMETRY_EVENT, handleGeometry)
    }, [])

    if (!geometry) return null

    const { x, y, radius } = geometry
    return (
        <Spotlight
            round
            dim={dim}
            // The only DOM proof a topic is spotlit.
            testId="guide-topic-spotlight"
            rect={{
                top: y - radius,
                left: x - radius,
                width: radius * 2,
                height: radius * 2,
            }}
        />
    )
}
